module.exports = "- open the inspector\n\n- call `render` every second\n\n- only the time is updated\n\nSo what's going on here?"


//////////////////
// WEBPACK FOOTER
// ./src/slides/08_clock/notes_3.md
// module id = 1510
// module chunks = 0